import auth0 from 'auth0-js';
import config from 'config';
import { encodeObjectToB64, formatDate } from 'libs/common';
import { parseQueryString } from 'libs/auth';

function getSignupUserMetaData(userInfo) {
  const {
    birthdate,
    given_name, family_name,
    chargebee_user_id
  } = userInfo;
  const user_metadata = {};

  if (birthdate) {
    user_metadata.birthdate = formatDate(birthdate, 'YYYY-MM-DD');
  }
  if (given_name) {
    user_metadata.given_name = given_name;
  }
  if (family_name) {
    user_metadata.family_name = family_name;
  }
  if (given_name && family_name) {
    user_metadata.name = `${given_name} ${family_name}`;
  }
  if (chargebee_user_id) {
    user_metadata.chargebee_user_id = chargebee_user_id;
  }

  return user_metadata;
}

function getWebAuth() {
  const webAuth = new auth0.WebAuth({
    domain: config.AUTH0.domain,
    clientID: config.AUTH0.clientId,
    scope: 'openid email profile',
    responseType: 'token id_token',
    audience: config.AUTH0.audience,
    redirect: false
  });

  return webAuth;
}

export function signinWebAuth(userInfo) {
  const webAuth = getWebAuth();
  return new Promise((resolve, reject) => {
    webAuth.client.login({
      realm: 'Username-Password-Authentication',
      username: userInfo.email,
      password: userInfo.password,
    }, (err, authResult) => {
      if (!err) {
        resolve(authResult);
      } else {
        reject(err);
      }
    });
  });
}

export function socialAuthorizationWebAuth(connection, userInfo = {}) {
  const webAuth = getWebAuth();
  const parsedQuery = parseQueryString();
  const { redirect, query } = parsedQuery || {};
  const objectString = encodeObjectToB64({ ...userInfo, redirect, query });

  return new Promise(() => {
    webAuth.authorize({
      connection,
      redirectUri: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
      state: objectString
    });
  });
}

export function resetPasswordWebAuth({ email }) {
  const webAuth = getWebAuth();
  return new Promise((resolve, reject) => {
    webAuth.changePassword({
      connection: config.AUTH0.connection,
      email,
    }, (err, res) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
}

export function signupWebAuth(userInfo) {
  const webAuth = getWebAuth();
  const user_metadata = getSignupUserMetaData(userInfo);
  return new Promise((resolve, reject) => {
    webAuth.signup({
      connection: config.AUTH0.connection,
      email: userInfo.email,
      password: userInfo.password,
      user_metadata
    }, (err, authResult) => {
      if (!err) {
        resolve(authResult);
      } else {
        reject(err);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/webAuth.js